import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import Apis from '../../api';
import { HEADERMENU_PATH } from '../../routes/RoutesURL';
import HSButton from '../common/Button';
import MessageActions from '../message/redux/actions';

type LocationType = {
    email: string | undefined;
};

const ForgotPasswordMessage: React.FC = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const location = useLocation();
    const stateData: { email: string | undefined } = location && (location.state as LocationType);
    const [loader, setLoader] = useState(false);

    const onClickResetEmailPassword = () => {
        setLoader(true);
        Apis.resendResetPasswordEmail({
            email: stateData.email && stateData.email.trim(),
        })
            .then(() => {
                dispatch(MessageActions.showMessage({ error: false, text: `Reset Password Email Sent SuccessFully` }));
            })
            .catch((err) => {
                dispatch(MessageActions.showMessage({ error: true, text: String(err) }));
            })
            .finally(() => {
                setLoader(false);
            });
    };

    return (
        <div className="h-full flex justify-center items-center">
            <div className="w-full" id="login">
                <div className="text-base text-center">
                    <p>Password Reset Email has been sent to your</p>
                    <p>
                        email id <span className="text-blue-400">{stateData && stateData.email}</span>
                    </p>
                    <p className="mt-4 mb-6">
                        If you haven't received this email, please click below to resend (sometimes system generated
                        emails could go into Spam instead of Inbox, so please check your Spam email folder, in case you
                        don't receive this email in your Inbox, even after resend)
                    </p>
                    <div className="flex justify-center items-center py-4 flex-col">
                        <HSButton
                            title="Send Reset password Email"
                            loading={loader}
                            onClick={onClickResetEmailPassword}
                        />
                        <HSButton
                            title="Return to Log in"
                            type="link"
                            onClick={() => navigate(HEADERMENU_PATH.login)}
                            className="mt-2 text-base text-black hover:text-black underline underline_b"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ForgotPasswordMessage;
